import {lazy} from 'react';

const AppComparison = lazy(() => import('../../pages/AppComparison'));

export default AppComparison;

